import { render } from "./ClassRecord.vue?vue&type=template&id=ecc4ca2a&ts=true"
import script from "./ClassRecord.vue?vue&type=script&lang=ts"
export * from "./ClassRecord.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__